module.exports = __webpack_public_path__ + "static/img/monument.95f3d30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/monument.jpg
// module id = AjKI
// module chunks = 1